import { type OrgScopedRoutePrefix } from './const';
import { buildOrgScopedPath } from './orgRouteUtils';

export type CanonicalLinkQuery = Record<string, string | null | undefined>;

const buildSearch = (query?: CanonicalLinkQuery): string => {
  if (!query) return '';

  const parts = Object.entries(query)
    .filter(([, value]) => value != null && value !== '')
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value!)}`
    );

  return parts.length ? `?${parts.join('&')}` : '';
};

const buildAppPath = (
  orgId: string,
  section: OrgScopedRoutePrefix,
  ...pathSegments: string[]
): string => buildOrgScopedPath(section, orgId, ...pathSegments);

export const buildRedirectUrl = (
  orgId: string,
  section: OrgScopedRoutePrefix,
  options?: {
    origin?: string;
    pathSegments?: string[];
    query?: CanonicalLinkQuery;
  }
): string => {
  const origin =
    options?.origin ??
    (typeof window !== 'undefined' ? window.location.origin : '');
  const pathname = buildAppPath(
    orgId,
    section,
    ...(options?.pathSegments ?? [])
  );

  return `${origin}${pathname}${buildSearch(options?.query)}`;
};
